import { CALENDAR_TIMESLOT_BASE_HEIGHT } from './constants';

export const getCalendarStyles = (theme, zoomLevel = 1.0, isMobile = false) => ({
  width: '100%',
  '& .rbc-calendar': {
    height: 'auto',
    fontFamily: theme.typography.fontFamily,
  },
  '& .rbc-header': {
    padding: isMobile ? '2px 1px' : 0,
    fontWeight: 600,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    borderBottom: 'none',
    borderTop: 'none',
    overflow: 'visible',
    pointerEvents: 'none',
    cursor: 'default',
    fontSize: isMobile ? '0.6rem' : 'inherit',
    lineHeight: isMobile ? 1.2 : 'inherit',
  },
  '& .rbc-time-header .rbc-header': {
    padding: isMobile ? '2px 1px' : 0,
    borderBottom: 'none',
    pointerEvents: 'none',
  },
  // Target the day/date text in the header (MON, TUE, Feb 2, etc.)
  '& .rbc-header > span, & .rbc-header > a': {
    fontSize: isMobile ? '0.6rem' : 'inherit',
  },
  '& .rbc-time-header-content': {
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  '& .rbc-allday-cell': {
    display: 'none',
  },
  '& .rbc-time-header-content > .rbc-row.rbc-row-resource': {
    display: 'none',
  },
  '& .rbc-today': {
    backgroundColor: 'transparent',
  },
  '& .rbc-off-range': {
    backgroundColor: theme.palette.grey[50],
  },
  '& .rbc-event': {
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    color: theme.palette.primary.contrastText,
    padding: isMobile ? '2px 4px' : '4px 8px',
    fontSize: isMobile ? '0.65rem' : '0.75rem',
    // Touch-friendly minimum size
    minHeight: isMobile ? '24px' : 'auto',
  },
  '& .rbc-event:hover': {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: theme.shadows[2],
  },
  '& .rbc-selected': {
    backgroundColor: theme.palette.primary.dark,
  },
  '& .rbc-slot-selection': {
    display: 'none',
  },
  '& .rbc-time-slot': {
    borderColor: theme.palette.divider,
  },
  // Control the height of each hour block for zoom functionality
  '& .rbc-timeslot-group': {
    minHeight: Math.round(CALENDAR_TIMESLOT_BASE_HEIGHT * zoomLevel),
    transition: 'min-height 0.2s ease-in-out',
  },
  '& .rbc-current-time-indicator': {
    backgroundColor: theme.palette.error.main,
    height: '2px',
  },
  '& .rbc-time-content': {
    borderColor: theme.palette.divider,
  },
  '& .rbc-toolbar button': {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  '& .rbc-toolbar button.rbc-active': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  '& .rbc-day-bg': {
    borderColor: theme.palette.divider,
  },
  '& .rbc-time-header-gutter': {
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.divider,
    // Smaller gutter on mobile for more calendar space
    width: isMobile ? '40px' : 'auto',
    minWidth: isMobile ? '40px' : 'auto',
  },
  '& .rbc-time-gutter': {
    // Smaller time labels on mobile
    fontSize: isMobile ? '0.65rem' : 'inherit',
  },
  '& .rbc-label': {
    fontSize: isMobile ? '0.65rem' : 'inherit',
    padding: isMobile ? '0 2px' : 'inherit',
  },
});
